import { useQuery } from '@tanstack/react-query'
import { ProjectService } from 'src/services/project.service'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { useTranslation } from 'react-i18next'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { ConfigurationHeaderWrapper } from '../_components/configuration-header-wrapper.component'
import PermissionList from 'src/pages/configuration/permissions/_components/permission-list.component'

export default function PermissionsPage() {
  const { t } = useTranslation()
  const { project } = useCurrentProject()

  const { isLoading, error, data } = useQuery({
    queryKey: ['permissions', project.id],
    queryFn: () => ProjectService.getPermissions(project.id),
  })

  if (error) {
    return <ErrorQueryHandler error={error} />
  }

  if (isLoading) {
    return <div className="loading" />
  }

  return (
    <ConfigurationHeaderWrapper title={t('pages.configuration.permissions.manage-permissions')}>
      {data && <PermissionList permissions={data} />}
    </ConfigurationHeaderWrapper>
  )
}
